/**
 * DataTab Component
 *
 * This component represents the data tab in the product management interface. It allows users to input and manage product-specific data such as SKU, regular price, and sale price. The component includes input fields for these details and a button to proceed to the next tab.
 *
 * File Name: DataTab.tsx
 * Date: 31-07-24
 */

import React from 'react';
import SimpleInput from '../../SimpleInput';
import { IProductsTabsProps } from 'src/types/GlobalInterfaces';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';

const DataTab: React.FC<IProductsTabsProps> = ({
    state,
    setState,
    tabChange
}) => {
    return (
        <>
            <div className='products-tabs-content'>

                <SimpleInput
                    value={state?.sku || ""}
                    onChange={(val) => setState("sku", val)}
                    isLabel={true}
                    labelText="SKU:"
                    maxLength={15}
                    isRequired={true}
                    type='text'
                    id="sku-input"
                />
                <SimpleInput
                    value={state?.regularPrice || ""}
                    onChange={(val) => setState("regularPrice", val)}
                    isLabel={true}
                    labelText="Regular Price:"
                    maxLength={15}
                    isRequired={true}
                    type='number'
                    id="regular-price-input"
                />
                <SimpleInput
                    value={state?.salePrice || ""}
                    onChange={(val) => setState("salePrice", val)}
                    isLabel={true}
                    maxLength={15}
                    labelText="Sale Price:"
                    type='number'
                    id="sale-price-input"
                />
            </div>
            {/* Button to proceed to the next tab */}
            <div className='flex justify-end my-6'>
                <PrimaryBtn
                    ButtonText="Next"
                    btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
                    id="next-tab-btn"
                    onPress={tabChange}
                />
            </div>
        </>
    );
};

export default DataTab;